import { memo } from "react";

import { ExternalLink } from "@/components/ui/button/external-link";

import { FormIslandSection } from "./island-section";

export const NewReleaseNote = memo(() => {
	// https://chillnn.notion.site/25cfffe15c5780508270c6b042971dff
	// https://chillnn.notion.site/e12fdd00e8a247cd97aef0ca33c1d9c0
	return (
		<FormIslandSection title="参考記事">
			<div className="flex flex-col items-start gap-y-0">
				<ExternalLink
					href="https://chillnn.notion.site/25cfffe15c5780508270c6b042971dff"
					text="プレーンの作成方法"
				/>
				<ExternalLink
					href="https://chillnn.notion.site/e12fdd00e8a247cd97aef0ca33c1d9c0"
					text="コンテンツを追加表示する方法"
				/>
			</div>
		</FormIslandSection>
	);
});
